import { gql } from "@apollo/client";
import { startsWith } from "lodash";

export const get_system_logs = gql`
  query SystemLogs(
    $where: SystemLogWhereInput
    $orderBy: [SystemLogOrderByWithRelationInput!]
    $take: Int
    $skip: Int
  ) {
    systemLogs(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      created_at
      code
      id
      metadata
      log_id
      log_type
      user {
        name
      }
    }
  }
`;

export const getSysLgVar = (code: string, take = 5) => ({
  where: { log_id: { startsWith: code } },
  orderBy: [{ created_at: "desc" }],
  take,
});

export const getSystemLogsVar = ({
  clinicId,
  startDate,
  endDate,
  searchText,
  take,
  skip,
  logType,
}: {
  clinicId: string;
  startDate: Date;
  endDate: Date;
  searchText: string | null;
  take: number;
  skip: number;
  logType: string[];
}) => {
  return {
    where: {
      code: { equals: clinicId },
      AND: [
        {
          OR: searchText
            ? [
                { log_id: { contains: searchText } },
                { code: { contains: searchText } },
                { metadata: { contains: searchText } },
              ]
            : undefined,
        },
        { created_at: { gte: startDate } },
        { created_at: { lte: endDate } },
        logType.length > 0 ? { log_type: { in: logType } } : undefined,
      ].filter(Boolean),
    },
    orderBy: [{ created_at: "desc" }],
    take,
    skip,
  };
};

export const create_one_sys_lg = gql`
  mutation CreateOneSystemLog($data: SystemLogCreateInput!) {
    createOneSystemLog(data: $data) {
      id
    }
  }
`;

export const createOneSysLogVar = (data: any) => ({ data });

export const get_total_logs_count = gql`
  query AggregateSystemLog($where: SystemLogWhereInput) {
    aggregateSystemLog(where: $where) {
      _count {
        id
      }
    }
  }
`;
